<template>
    <div class="mr-3 rounded shadow-md bg-white p-0">
        <div class="mb-2 w-full border-b-0 border-followup-nav contactTabs required-field-tabs">
            <button v-for="tab in tabs" :key="tab" :id="`${tab}Tab`" @click="changeTab($event, tab);" class="tab-btn">
                {{ tab }}
            </button>
            <component :is="selectedTab" class="tab tab-body-custom-class" :fieldLabels="fieldLabels" :recordDetailFieldLabels="recordDetailFieldLabels">
                <slot></slot>
            </component>
        </div>
    </div>
</template>

<script>
import ProjectRequiredFields from "./project/project-required-fields.vue";
import CompanyRequiredFields from "./company/company-required-fields.vue";
import ContactRequiredFields from "./contact/contact-required-fields.vue";

export default {
    name: "required-fields",
    props:['fieldLabels', 'recordDetailFieldLabels'],
    components: {ProjectRequiredFields, CompanyRequiredFields, ContactRequiredFields},
    data() {
        return {
            tabs: ["Project", "Company", "Contact"],
            selectedTab: 'ProjectRequiredFields'
        }
    },
    mounted() {
        $('#ProjectTab').addClass('required-field-active-tab');
    },
    methods: {
        changeTab(event, tab) {
            let self = this;
            let elementId = '#' + event.target.id;
            $('.tab-btn').removeClass('required-field-active-tab');
            $(elementId).addClass('required-field-active-tab');
            switch(tab) {
                case 'Project':
                    self.selectedTab = 'ProjectRequiredFields';
                    break;
                case 'Company':
                    self.selectedTab = 'CompanyRequiredFields';
                    break;
                case 'Contact':
                    self.selectedTab = 'ContactRequiredFields';
                    break;
                default:
                    self.selectedTab = 'ProjectRequiredFields';
            }
        }
    }
};
</script>

<style scoped>
.tab-btn {
    padding: 6px 10px;
    /*background: #14b1af;*/
    cursor: pointer;
    margin-bottom: 1rem;
    outline: none;
    color: #32363a;
    height: 41px;
    width: 110px;
}
.required-field-tabs {
    background: #f1f3f9;
}
.required-field-active-tab {
    color: #01b1af;
    border-bottom: 1px solid #01b1af;
}
</style>
